import $ from 'jquery'
import Swal from 'sweetalert2'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'

// eslint-disable-next-line no-undef
const form = $('.contact-form');
const object = autostrategyObject;

const alert = Swal.mixin({})
export const Alert = (success = true, message = '', duration = 6000) => {
    let type
    if (typeof success === 'boolean') {
        type = success ? 'success' : 'error'
    } else {
        type = success
    }

    alert.fire({
        icon: type,
        title: message,
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: duration,
        timerProgressBar: true,
        iconColor: 'white',
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
            toast.addEventListener('click', Swal.close)
        },
    })
}

if (form.length) {
    form.parsley().on('form:success', function () {
        form.attr('data-success', 'true')
    })

    form.parsley().on('form:error', function () {
        form.attr('data-success', 'false')
    })

    form.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()
        e.stopImmediatePropagation()

        const formData = new FormData($(this)[0])
        formData.append('action', 'autostrategy_contact_form')
        formData.append('nonce', object.nonce)


        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                form.addClass('sending')
                Alert('warning', object.formWait)
            },
            processData: false,
            contentType: false,
            success: function (res) {
                form.removeClass('sending')
                Alert(res.success, res.data.message)
                if (res.success) {
                    form.get(0).reset();
                }
                if (res.data.redirect) {
                    window.location.href = res.data.redirect
                }
            },
            error: function (res) {
                if (res.data) {
                    Alert(res.error, res.data.message, 'error-msg')
                }
            }
        })
    })
}